import { executeHttpCall } from '@/services/httpClientHelper.js'

const ecuReport = {
  namespaced: true,
  state: {
    reportTypes: {
      error: false,
      loading: false,
      options: []
    },
    selected: {
      customReportLink: null,
      ecuTypeActive: '',
      ecuProperties: {
        ecus: []
      }
    },
    allEcusSelected: false
  },
  mutations: {
    reportTypes (state, payload) {
      state.reportTypes[payload.propName] = payload.value
    },
    selected (state, payload) {
      state.selected[payload.propName] = payload.value
    },
    allEcusSelected (state, payload) {
      state.allEcusSelected = payload
    },
    overwriteSelected (state, newVal) {
      state.selected = newVal
    },
    setDefaultState (state) {
      state.reportTypes = {
        error: false,
        loading: false,
        options: []
      }
      state.postReport = {
        error: false,
        loading: false,
        response: null
      }
    },
    setDefaultSelectionState (state) {
      state.selected = {
        customReportLink: null,
        ecuTypeActive: '',
        ecuProperties: {
          ecus: []
        }
      }
    }
  },
  getters: {
    isAllEcusSelected: state => {
      return state.allEcusSelected
    },
    getAllSelections: state => {
      return state.selected
    }
  },
  actions: {
    loadStateFromFile ({ commit }, data) {
      commit('overwriteSelected', data)
    },
    getEcuReportTypes ({ commit }) {
      commit('reportTypes', { propName: 'options', value: [] })
      commit('reportTypes', { propName: 'error', value: false })
      commit('reportTypes', { propName: 'loading', value: true })

      const params = {
        resultFile: 'EcuRepTy',
        _program: 'GetEcuReportTypes'
      }
      executeHttpCall(params, null).then(result => {
        commit('reportTypes', { propName: 'optionsFiltered', value: JSON.parse(JSON.stringify(result).replaceAll('Visual analytics - ', '')) })
        commit('reportTypes', { propName: 'options', value: result })
      }).catch(error => {
        console.error('getEcuReportTypes:', error)
        commit('reportTypes', { propName: 'error', value: true })
      }).finally(() => {
        commit('reportTypes', { propName: 'loading', value: false })
      })
    },
    updateSelection ({ commit }, payload) {
      console.log('payload' + payload)
      commit('selected', payload)
    },
    reset ({ commit }) {
      commit('setDefaultState')
      commit('setDefaultSelectionState')
    }
  }
}
export default ecuReport
